import formatUrl from '@tcs/common/utils/formatUrl';
import axios, { AxiosRequestConfig } from 'axios';
import {
  MutationFunction,
  MutationOptions,
  QueryClient,
  QueryFunction,
  QueryFunctionContext,
} from 'react-query';
export { useQuery, useQueryClient } from 'react-query';
export type { MutationKey } from 'react-query/types/core';

const maxRetryCount = 2;

const createRequestConfig = async (): Promise<AxiosRequestConfig> => {
  const config: AxiosRequestConfig = {
    headers: {},
    withCredentials: true,
  };
  return config;
};

const createQueryFn =
  (apiBaseUrl: string) =>
  async <TQueryResponse>({
    queryKey,
  }: QueryFunctionContext): Promise<QueryFunction<TQueryResponse>> => {
    const config = await createRequestConfig();

    const { data } = await axios.get(
      `${formatUrl(apiBaseUrl)}/api/${queryKey}`,
      config
    );

    return data;
  };

const createMutationFn =
  (apiBaseUrl: string) =>
  async ({
    mutationKey,
    ...rest
  }: MutationOptions): Promise<MutationFunction<any, any>> => {
    const config = await createRequestConfig();

    const { data } = await axios.put(
      `${formatUrl(apiBaseUrl)}/api/${mutationKey}`,
      { ...rest },
      config
    );

    return data;
  };

export const queryClient = (apiBaseUrl: string) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        queryFn: createQueryFn(apiBaseUrl),
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retry: maxRetryCount,
      },
      mutations: {
        mutationFn: createMutationFn(apiBaseUrl),
        retry: false,
      },
    },
  });
